import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
        
        this.events = {
          click: {
              close: 'menuClose'
          }
        };

        this.fadeIn = this.el.animate([
          { background: "rgba(255,255,255,0)" },
          { background: "rgba(255,255,255,0.8)" },
        ], {
          duration: 200,
          fill: "forwards",
          easing: "ease-in-out",
        });

        this.fadeIn.pause();

        this.slideIn = this.$('menu')[0].animate([
          { transform: "translate(100%,0)" },
          { transform: "translate(0%,0)" },
        ], {
          duration: 200,
          fill: "forwards",
          easing: "ease-in-out",
        });
        this.slideIn.pause();
      

    }

    menuOpen() {
      document.body.style.overflow = "hidden"
      this.el.style.display = "flex"
      this.fadeIn.playbackRate = 1;
      this.slideIn.playbackRate = 1;
      this.fadeIn.play();
      this.slideIn.play();
      this.call('cartClose', null, 'Headerfloat');

      this.fadeIn.finished.then(() => {
        this.fadeIn.pause();
      })

      this.slideIn.finished.then(() => {
        this.slideIn.pause();
      })
    }


    menuClose() {
      this.fadeIn.reverse();
      this.slideIn.reverse();

      this.fadeIn.finished.then(() => {
        document.body.style.overflow = "auto"
        this.el.style.display = "none"
        this.fadeIn.pause();
      })

      this.slideIn.finished.then(() => {
        this.slideIn.pause();
      })

    }
}
